import { load, PlainConfig } from "hybridconfig";

type AllowedKeys =
  | "metaUrl"
  | "aptRepoUrl"
  | "aptRepoSourceName"
  | "aptPackageName"
  | "yumRepoUrl"
  | "yumRepoSourceName"
  | "yumPackageName";

const config = load<AllowedKeys>({
  remoteConfigPath: "/config.json",
  envKeyPrefix: "APP_",
});

export type Config = PlainConfig<AllowedKeys>;

export default config;
